type CallbackFn = () => void;

export function makeSyncStoreUtil(parentStore?: {trigger: () => void}) {
  const subscribers = new Set<CallbackFn>();

  function subscribe(fn: CallbackFn) {
    subscribers.add(fn);
    return () => {
      // not drizzle code! :)
      // eslint-disable-next-line drizzle/enforce-delete-with-where
      subscribers.delete(fn);
    };
  }

  function trigger() {
    parentStore?.trigger();
    for (const onSnapshot of subscribers) {
      onSnapshot();
    }
  }

  return {
    subscribe,
    trigger,
  };
}
